export const SET_ROLES = 'SET_ROLES';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';